import React from 'react';
import ServiceTemplate from '../components/ServiceTemplate';

const ExportSolutions = () => {
  return (
    <ServiceTemplate
      title="Export Solutions"
      subtitle="Exporting from South Africa"
      description="End-to-end export support from South Africa to Europe and Africa, handling documentation, freight, and customs."
      whatIsIt="Export solutions cover the complete process of sending goods from South Africa to Europe and Africa. This includes collection from your South African location, export customs clearance, freight coordination (air or ocean), and delivery to international destinations. NETEXEC GLOBAL manages the entire export process."
      whoFor="This service is for South African businesses exporting products, goods, or materials to Europe and Africa. It's ideal for manufacturers, distributors, and exporters who need reliable logistics coordination for international sales."
      whenToUse="Use export solutions when you're selling goods to international customers and need freight and customs support. Whether it's regular export shipments or expanding into new markets, end-to-end export coordination ensures smooth processing and delivery."
      howWeHelp="NETEXEC GLOBAL coordinates your exports from South African origin to international destination. We arrange collection, handle export documentation, coordinate South African customs clearance, book freight (air or ocean), and manage delivery at destination."
      benefits={[
        'Complete export coordination from South Africa',
        'Expert South African export customs clearance',
        'Freight booking (air or ocean) to Europe and Africa',
        'Compliance with export regulations and documentation',
        'Destination customs coordination and delivery'
      ]}
      nextSteps="Contact NETEXEC GLOBAL with your cargo details, collection location in South Africa, and international destination. We'll coordinate the complete export process with transparent pricing and reliable timelines."
      image="https://images.unsplash.com/photo-1769997768068-4dc032f4c509?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
    />
  );
};

export default ExportSolutions;